angular
    .module('annexaApp')
    .component('annexaProfileEdit',{
        templateUrl: './components/common/annexa-profile-edit/annexa-profile-edit.html',
        controller: ['$rootScope', 'Language', 'RegFactory', 'HelperService', function($rootScope, Language, RegFactory, HelperService) {
            var vm = this;

            vm.languageColumn = Language.getActiveColumn();

            if (!vm.title) {
                vm.title = 'global.literals.profile';
            }
            if (!vm.profiles) {
            	var selectableOptions = [];
                _.forEach($rootScope.LoggedUser.userProfiles, function (value, key) {
                	var haveProfile = false;
                    if(value.profile.expiryDate == null || (vm.model && vm.model.id && vm.model.id == value.profile.id)) {
                        selectableOptions.push(value);
                    }
                });
                vm.profiles = $linq(selectableOptions).distinctBy("x => x.profile.id").select("x => x.profile").orderBy("x => x." + Language.getActiveColumn(), HelperService.caseInsensitiveOrNullComparer).toArray();
            }

            vm.updateProfile = function(profile) {
                switch (vm.type) {
                    case 'registerEntry':
                        $rootScope.$broadcast('AnnexaProfileEditUpdated', { profile: profile });
                        break;
                }
            }

            this.$onInit = function () {
                if(vm.permissions && Array.isArray(vm.permissions) && vm.permissions.length == 0) {
                    vm.permissions.push('no_edit');
                }
                if(vm.profiles && vm.profiles.length != 0) {
                    vm.model =  $linq(vm.profiles).singleOrDefault(vm.model, "x => x.id == " + vm.model.id);
                }
            }
        }],
        bindings: {
            model: '=',
            type: '@',
            permissions: '=',
            disabled: '='
        }
    })